export default __webpack_public_path__ + "static/media/WarningIcon.41e00337.svg";